import { I as Icon } from "../Icon.js";
import { L as LazyIcon } from "../LazyIcon.js";
import { isComponent } from "../utils/component.js";
const useIcons = (children) => {
  let leftIcon = null;
  let rightIcon = null;
  const firstChild = children[0];
  if (isComponent(firstChild, Icon) || isComponent(firstChild, LazyIcon)) {
    leftIcon = firstChild;
    children.shift();
  }
  const lastChild = children[children.length - 1];
  if (isComponent(lastChild, Icon) || isComponent(lastChild, LazyIcon)) {
    rightIcon = lastChild;
    children.pop();
  }
  const restChildren = children.filter((child) => child);
  return [leftIcon, rightIcon, restChildren.length > 0 ? restChildren : null];
};
export {
  useIcons
};
//# sourceMappingURL=useIcons.js.map
